import { AppConstants } from "../app/appConstants";

export const defaultValuesForEnvironment = {
  serviceWorker: false,
  BACKURL: '/',
  LOGO: 'assets/img/logo-sanidad.png',
  ADDRESS: '',
  NAME: '',
  PHONE: '',
  EMAIL: '',
  MAILTOCOMUNICATIONS: 'webmaster@commonms.com',
  ANIMATIONS: AppConstants.ANIMATIONS, // Animations of some components
  NAVBARMAINCOLOR: false, // If navbar use main or secundary color
  ADMINNAVBAR: {
    HAS: false,
    USERMANGEMENT: false,
    PORTAL_CONFIGURATION: false,
    REPORTS: {
      HAS: true,
      DELETED_USERS: false,
      REGISTER_USERS: true,
      LOGIN_ATTEMPS: true,
      DATABASE_LOGS: false,
    },
  },
  APPINPLAYSTORE: false,
  PLAYSTOREAPPURL: '',
  OPTIONAL_FIELDS_FOR_BOOKAPPOINTMENTS: {
    SUBDEPARTMENT: false,
    TIMEFRAME: false
  },
  HASCOOKIEBAR: false,
  HASMYDEPENTS: false,
  HASMYDOCUMENTS: false,
  HASCAPTCHA: false,
  VIDEOCALL: {
    HAS: false,
    SERVERURL: 'https://etrial.herokuapp.com',
    COMPONENTURL: 'https://crux.commonms.com/pcdemo/vcdemo/'
  },
  HIDELANGUAGESELECTOR: false,
  DEFAULTLANGUAGE: 'es',
  HASSECONDOPINION: false,
  SECONDOPINION: {
    HAS: false,
    SUBJECTFORHOSPITAL: 'New request for second opinion from the web',
    SUBJECTFORUSER: 'Thanks for your second opinion request',
    MESSAGEFORUSER: '<p>As soon as we receive your transfer to account number XXXX XXXX XXXXX XXXX XXXX our team will contact you to offer you our opinion on your case<p/>',
  },
  OPTIONAL_FIELDS_FOR_REGISTER: {
    STATE: false,
    SOCIAL_SECURITY_NUMBER: false,
    DOCNUMBER: false,
    GENDER: false,
    LANGUAGE: false,
    SECOND_SURNAME: false
  },
  OPTIONAL_FIELDS_FOR_SLOTS: {
    NOTIFICATIONS: false,
    COMENTS: false
  },
  REGISTER_ONLY_WITH_PIN: false,
  BUTTONS_ON_MY_APPOINTMENTS: {
    PRINT: false
  },
  MAXINACTIVETIME: 1000 * 60 * 5, // Time for auto log out. Must be the same as t_parameters.TOKEN_TIMEOUT_MINUTES in DB
  HOURS_TO_CANCEL_APPOINTMENTS: 0,  // Horas antes de la cita en que ya no es imposible cancelarla
  NEED_CONFIRM_APPOINTMENTS: false, // Si se necesita confirmar la  cita. Si esta a true hay que rellenar los dias entre los que se hará
  RESOURCES_ON_DATABASE: false, // Si es verdad los recursos (hospitales y demás) se piden a la base de datos, sino se piden a ISH
  RESOURCES_ON_SYNC: false // Si false todo se gestiona desde BBDD, Si se usa "ISH" se pide ahí... otros valores se podrán usar a futuro
};
